import { MenuProps } from "antd";
import { menuIcons } from "@/layout/menuItemsMock";
import { Access } from "@/features/farmer/domain/farmer-interface";

export const generateMenu = (access: Access[]): MenuProps["items"] => {
  return access?.flatMap((item, iIdx) => {
    if (item.status !== "HIDDEN") {
      const menu = {
        disabled: item?.status === "INACTIVE",
        label: item?.text,
        icon: <img width={36} src={menuIcons(item)} alt={item.name} />,
        key: item.route || `unknown-${iIdx}`,
        className: `!rounded-[12px] !my-[10px] overflow-hidden !py-[8px] ${
          item.children ? "text-base" : "text-sm"
        }`,
        children:
          item.children && item.children.length > 0
            ? generateMenu(item.children)
            : undefined,
      };
      return [menu];
    }
    return [];
  });
};
